import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class NoAuthInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.endsWith('/health')) {
      // Supprime le header Authorization si présent
      const headers = request.headers.delete('Authorization');
      const cloned = request.clone({ headers });
      return next.handle(cloned);
    }
    return next.handle(request);
  }
}